module.exports = __webpack_public_path__ + "static/media/IMG_9115a.c81b61a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/akopan/IMG_9115a.jpg
// module id = 98
// module chunks = 0